var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dij-ptb",class:{
    'dij-ptb--done': _vm.completed,
    'dij-ptb--hidden': !_vm.demo && _vm.value === null,
  }},[_c('div',{staticClass:"dij-ptb__track"},[_c('div',{staticClass:"dij-ptb__fill",style:({ width: _vm.progress + '%' })},[_c('span',{staticClass:"dij-ptb__shimmer"}),(_vm.progress > 0 && _vm.progress < 100)?_c('span',{staticClass:"dij-ptb__pulse"}):_vm._e()]),_c('span',{staticClass:"dij-ptb__label"},[(_vm.message)?_c('span',{staticClass:"dij-ptb__message"},[_vm._v(_vm._s(_vm.message))]):_vm._e(),_vm._v(" "+_vm._s(Math.round(_vm.progress))+"% ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }